import React, { useRef, useEffect } from 'react';
import get from 'lodash/get';
import { Chart } from 'chart.js';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import { injectIntl } from 'react-intl';

import '../../extensions';
import Icon from '../../../../Icon';
import Loader from '../../../Loader';
import { useChartContext } from '../../hooks';

import styles from './styles.styl';

const ChartCanvas = ({ config, loading, intl: { formatMessage } }) => {
  const ref = useRef(null);
  const { chart, setChart } = useChartContext();

  const nothing = isEmpty(get(config, 'data.datasets', []));

  useEffect(() => {
    if (chart) chart.destroy();
    const canvas = ref && ref.current.getContext('2d');
    if (!loading && !nothing) setChart(new Chart(canvas, config));
  }, [ref, config, loading]);

  return (
    <div className={styles.canvas}>
      <canvas ref={ref} />

      <div className={styles.info}>
        {loading && <Loader />}

        {!loading && nothing && (
          <div className={styles.empty}>
            <Icon name="ico-1000-graph" size={60} />

            <div className={styles.description}>
              {formatMessage({ id: 'patient.healthboard.graf.emptyState' })}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

ChartCanvas.propTypes = {
  loading: PropTypes.bool,
  config: PropTypes.object,
  intl: PropTypes.object.isRequired,
};

export default injectIntl(ChartCanvas);



// WEBPACK FOOTER //
// ./src/components/common/Charts/ChartWrapper/ChartCanvas/index.jsx